export default "__VITE_ASSET__DnxOuRZn__"